/**
 * True when running inside the Capacitor native shell (app/ — the customer
 * app wrapping this LIFF bundle). Capacitor injects window.Capacitor into its
 * WebView; the check needs no dependency on @capacitor/core, so the LIFF
 * bundle stays identical for the in-LINE deployment.
 *
 * Mirrors the operator app's convention (web/ ↔ mobile/).
 */
type CapacitorGlobal = { isNativePlatform?: () => boolean }

export const isNativePlatform = (): boolean =>
  !!(window as { Capacitor?: CapacitorGlobal }).Capacitor?.isNativePlatform?.()

/**
 * 'ios' | 'android' | 'web' — Capacitor's platform string, or 'web' outside
 * the shell. Used to gate the iOS-only safe-area-top floor (the WKWebView
 * reports env(safe-area-inset-top) as 0 while rendering edge-to-edge; the
 * Android shell keeps the webview below the status bar at targetSdk 34, so
 * it must NOT get the floor).
 */
type CapacitorPlatformGlobal = CapacitorGlobal & { getPlatform?: () => string }

export const getNativePlatform = (): string =>
  (window as { Capacitor?: CapacitorPlatformGlobal }).Capacitor?.getPlatform?.() ?? 'web'
